import { Editor } from '@tiptap/core'

import { PollNode } from './index.js'

export function getEditorPollIds(editor: Editor) {
  return editor
    .$nodes(PollNode.name)
    .map(node => node.attributes?.id)
    .filter(Boolean)
}
